import { getLabel } from "../labels";

export function getRelativeDay(date) {
	try {
		const todayLabel = getLabel('general.today');
		const tomorrowLabel = getLabel('general.tomorrow');
		if (todayLabel == null || tomorrowLabel == null) {
			return null;
		}

		const inputDate = new Date(date);
		inputDate.setHours(0, 0, 0, 0);
        const inputDateTime = inputDate.getTime();

		const today = new Date();
		today.setHours(0, 0, 0, 0);
		if (today.getTime() === inputDateTime) {
			return todayLabel;
		}

		const tomorrow = new Date(today)
		tomorrow.setDate(today.getDate() + 1);
		if (tomorrow.getTime() === inputDateTime) {
			return tomorrowLabel;
		}
	} catch(e) {
		console.error(e);
		return null;
	}

	return null;
}
